// Archived games as the server sends them to the browser, and the pure folds that turn them into
// stats. Nothing is computed at archive time, so changing what counts needs no migration.
/** The side a team plays for, or null for a team with no fixed side. */
export function alignmentOf(team) {
    if (team === "townsfolk" || team === "outsider")
        return "good";
    if (team === "minion" || team === "demon")
        return "evil";
    return null;
}
/** true / false, or null when there's no answer — no alignment, or the game has no recorded winner. */
export function playerWon(player, game) {
    const side = player.alignment;
    if (!side || !game.winningTeam)
        return null;
    return side === game.winningTeam;
}
/** Your seat in a game, if you had one. */
export function seatOf(game, profileId) {
    return game.players.find((p) => p.profileId === profileId) ?? null;
}
export function storytold(game, profileId) {
    return game.storytellers.some((s) => s.profileId === profileId);
}
function tallyRole(roles, player, game) {
    if (!player.characterId)
        return;
    const entry = roles.get(player.characterId) ?? {
        characterId: player.characterId,
        characterName: player.characterName ?? player.characterId,
        team: player.team,
        count: 0,
        wins: 0,
        decided: 0,
    };
    entry.count += 1;
    const won = playerWon(player, game);
    if (won !== null) {
        entry.decided += 1;
        if (won)
            entry.wins += 1;
    }
    roles.set(player.characterId, entry);
}
function sortRoles(roles) {
    return [...roles.values()].sort((a, b) => b.count - a.count || a.characterName.localeCompare(b.characterName));
}
export function personalStats(games, profileId) {
    const stats = { played: 0, wins: 0, losses: 0, good: 0, evil: 0, survived: 0, storytold: 0, roles: [] };
    const roles = new Map();
    for (const game of games) {
        if (storytold(game, profileId))
            stats.storytold += 1;
        const me = seatOf(game, profileId);
        if (!me)
            continue;
        stats.played += 1;
        if (me.aliveAtEnd)
            stats.survived += 1;
        const side = me.alignment;
        if (side === "good")
            stats.good += 1;
        if (side === "evil")
            stats.evil += 1;
        const won = playerWon(me, game);
        if (won === true)
            stats.wins += 1;
        if (won === false)
            stats.losses += 1;
        tallyRole(roles, me, game);
    }
    stats.roles = sortRoles(roles);
    return stats;
}
//# sourceMappingURL=index.js.map